import validateAndCreateHash from "@/helpers/sign/validateAndCreateHash.js";

export default function (thumbprint, content) {
    const { createDetachedSignature } = window.cryptoPro;
    return validateAndCreateHash(content)
        .then(hash => createDetachedSignature(thumbprint, hash))
        .then(sig => {
            if (sig.startsWith('-----BEGIN')) return sig;

            return `-----BEGIN PKCS7-----\n${sig}\n-----END PKCS7-----\n`;
        });
}
